// Deprecated: Use @mds/core-web/components/FileUpload instead.
// This only exists for backwards compatibility purposes and should be removed when all imports have been updated.
import RenderFileUpload from "@mds/common/components/forms/RenderFileUpload";

export default RenderFileUpload;
